import React, { useState } from "react";
import styles from "../styles/UlcPremiumCalculator.module.css";

const SchemeHolderForm = () => {
  const [formData, setFormData] = useState({
    district: "",
    taluka: "",
    village: "",
    surveyNumber: "",
    area: "",
    exemptionType: "",
    premiumFactor: "",
    rrRate: "",
    ulcPremiumAmount: "",
  });

  // Premium Factor mapping
  const premiumFactors = {
    Residential: 13,
    Industrial: 15,
    Agricultural: 10,
    Commercial: 20,
    Redevelopment: 2.5,
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Autofill premium factor when exemption type changes
    if (name === "exemptionType") {
      const factor = premiumFactors[value] || "";
      setFormData((prev) => ({
        ...prev,
        exemptionType: value,
        premiumFactor: factor,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Calculation formula
  const handleSubmit = (e) => {
    e.preventDefault();
    const { area, rrRate, premiumFactor } = formData;

    const areaNum = parseFloat(area);
    const rrRateNum = parseFloat(rrRate);
    const factorNum = parseFloat(premiumFactor);

    if (isNaN(areaNum) || isNaN(rrRateNum) || isNaN(factorNum)) {
      alert("Please fill valid numerical values for Area, RR Rate, and Premium Factor.");
      return;
    }

    const ulcAmount = areaNum * rrRateNum * (factorNum / 100);
    setFormData((prev) => ({
      ...prev,
      ulcPremiumAmount: ulcAmount.toFixed(2),
    }));
  };

  return (
    <form className={styles.calculatorULC_form} onSubmit={handleSubmit}>
      <div className={styles.calculatorULC_inputGroup}>
        <label>District</label>
        <select
          name="district"
          className={styles.calculatorULC_input}
          value={formData.district}
          onChange={handleChange}
        >
          <option value="">Select District</option>
          <option value="Kolhapur">Kolhapur</option>
          <option value="Mumbai">Mumbai</option>
          <option value="Nagpur">Nagpur</option>
          <option value="Nashik">Nashik</option>
          <option value="Pune">Pune</option>
          <option value="Sangli">Sangli</option>
          <option value="Solapur">Solapur</option>
          <option value="Thane">Thane</option>
          <option value="Ulhasnagar">Ulhasnagar</option>
        </select>
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Taluka</label>
        <input
          type="text"
          name="taluka"
          className={styles.calculatorULC_input}
          placeholder="Enter Taluka"
          value={formData.taluka}
          onChange={handleChange}
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Village</label>
        <input
          type="text"
          name="village"
          className={styles.calculatorULC_input}
          placeholder="Enter Village"
          value={formData.village}
          onChange={handleChange}
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Survey Number</label>
        <input
          type="text"
          name="surveyNumber"
          className={styles.calculatorULC_input}
          placeholder="Enter Survey Number"
          value={formData.surveyNumber}
          onChange={handleChange}
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Area of Excess Land (m²)</label>
        <input
          type="number"
          name="area"
          className={styles.calculatorULC_input}
          placeholder="Enter Area"
          step="0.01"
          value={formData.area}
          onChange={handleChange}
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Exemption Type</label>
        <select
          name="exemptionType"
          className={styles.calculatorULC_input}
          value={formData.exemptionType}
          onChange={handleChange}
        >
          <option value="">Select Type</option>
          <option>Residential</option>
          <option>Industrial</option>
          <option>Agricultural</option>
          <option>Commercial</option>
          <option>Redevelopment</option>
        </select>
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Premium Factor (%)</label>
        <input
          type="text"
          name="premiumFactor"
          className={styles.calculatorULC_input}
          placeholder="Unknown"
          value={formData.premiumFactor}
          readOnly
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>
          Ready Reckoner Rate (Rs/m²)
          <a
            href="https://www.igrmaharashtra.gov.in/eASR/.frmMap.aspx"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: "8px", fontSize: "12px" }}
          >
            (Check RR Rate)
          </a>
        </label>
        <input
          type="number"
          name="rrRate"
          className={styles.calculatorULC_input}
          placeholder="Enter Rate"
          value={formData.rrRate}
          onChange={handleChange}
        />
      </div>

      <button type="submit" className={styles.calculatorULC_submitButton}>
        Submit
      </button>

      {formData.ulcPremiumAmount && (
        <div className={styles.calculatorULC_inputGroup}>
          <label>ULC Premium Amount (₹)</label>
          <input
            type="text"
            className={styles.calculatorULC_input}
            value={formData.ulcPremiumAmount}
            readOnly
          />
        </div>
      )}
    </form>
  );
};

export default SchemeHolderForm;
